import React, { useEffect, useState } from "react";
import API from "../../services/api";

export default function LeadModal({
  modalRef,
  form,
  editId,
  onChange,
  onSubmit,
  submitLoading,
  onCancelEdit,
  validated,
  errors,
}) {
  const [positions, setPosition] = useState([]);

  useEffect(() => {
    const fetchMaster = async () => {
      try {
        const positionRes = await API.get("/position");
        setPosition(positionRes.data);
      } catch (err) {
        console.error("Gagal load master:", err);
      }
    };
    fetchMaster();
  }, []);

  return (
    <form
      noValidate
      className={validated ? "was-validated" : ""}
      onSubmit={onSubmit}
    >
      <div
        className="modal fade"
        id="leadModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modalLabel"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg modal-lead">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalLabel">
                {editId ? "Edit Lead" : "Tambah Lead"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-2">
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={onChange}
                    className={`form-control ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    placeholder="Nama"
                    required
                  />
                  <div className="invalid-feedback">
                    {errors.name || "Nama wajib diisi."}
                  </div>
                </div>

                <div className="col-md-6 mb-2">
                  <input
                    type="text"
                    name="phone_number"
                    value={form.phone_number}
                    onChange={onChange}
                    className={`form-control ${
                      errors.phone_number ? "is-invalid" : ""
                    }`}
                    placeholder="Nomor Telepon"
                    required
                  />
                  <div className="invalid-feedback">
                    {errors.phone_number || "Nomor Telepon wajib diisi."}
                  </div>
                </div>
                <div className="col-md-6 mb-2">
                  <select
                    className="form-select"
                    name="klpd"
                    value={form.klpd || ""}
                    onChange={onChange}
                    required
                  >
                    <option value="">-- Pilih KLPD --</option>
                    <option value="Kementerian">Kementerian</option>
                    <option value="Lembaga">Lembaga</option>
                    <option value="Pemerintah Daerah">Pemerintah Daerah</option>
                    <option value="Belum diketahui">Belum diketahui</option>
                  </select>
                  <div className="invalid-feedback">KLPD wajib diisi.</div>
                </div>

                <div className="col-md-6 mb-2">
                  <select
                    className="form-select"
                    name="position_id"
                    value={form.position_id || ""}
                    onChange={onChange}
                    required
                  >
                    <option value="">-- Pilih Jabatan --</option>
                    {positions.map((position) => (
                      <option key={position.id} value={String(position.id)}>
                        {position.initials}
                      </option>
                    ))}
                  </select>
                  <div className="invalid-feedback">Jabatan wajib diisi.</div>
                </div>

                <div className="col-md-6 mb-2">
                  <input
                    type="text"
                    name="institution_or_business"
                    value={form.institution_or_business}
                    onChange={onChange}
                    className="form-control"
                    placeholder="Instansi / Satker"
                    required
                  />
                  <div className="invalid-feedback">
                    Instansi / Satker wajib diisi.
                  </div>
                </div>

                <div className="col-md-6 mb-2">
                  <textarea
                    type="text"
                    name="location"
                    value={form.location}
                    onChange={onChange}
                    className="form-control"
                    placeholder="Lokasi"
                    required
                    rows={4}
                  />
                  <div className="invalid-feedback">Lokasi wajib diisi.</div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {editId && (
                <button
                  type="button"
                  className="btn btn-secondary me-auto"
                  onClick={onCancelEdit}
                >
                  Batal Edit
                </button>
              )}
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitLoading}
              >
                {submitLoading ? "Memproses..." : editId ? "Update" : "Tambah"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
